// extracted by mini-css-extract-plugin
export default {"bowl-games-list":"bowl-list_bowl-games-list__mZeWU"};